import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer" }
const _hoisted_2 = { class: "user-header" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "C/O", -1)
const _hoisted_5 = { class: "col-sm-4" }
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Address", -1)
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Address Line 2")
], -1)
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "City", -1)
const _hoisted_14 = { class: "col-sm-3" }
const _hoisted_15 = { class: "form-group row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "County", -1)
const _hoisted_17 = { class: "col-sm-3" }
const _hoisted_18 = { class: "form-group row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Postcode", -1)
const _hoisted_20 = { class: "col-sm-2" }
const _hoisted_21 = { class: "form-group row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Phone", -1)
const _hoisted_23 = { class: "col-sm-2" }
const _hoisted_24 = { class: "form-group row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "HQ Branch", -1)
const _hoisted_26 = { class: "col-sm-4" }
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Editable", -1)
const _hoisted_29 = { class: "col-sm-4" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { Customer } from "@/models";
import { DxSwitch } from 'devextreme-vue/switch';


export default /*#__PURE__*/_defineComponent({
  __name: 'Address',
  setup(__props) {

const store = useStore();
const customer = computed(() => store.getters['customers/current']);
const editCustomer = async (customer: Customer) => await store.dispatch('customers/editCustomer', customer);
const setCustomerDeep = async (payload: {
  path: string;
  data: any;
}) => {
  await store.dispatch('customers/setCustomerDeep', payload);
}
const editCurrentCustomer = () => {
  editCustomer(customer.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customer.value.co) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.co,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customer.value.address.line1) = $event)),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.address.line1,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customer.value.address.line2) = $event)),
                onChange: _cache[5] || (_cache[5] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.address.line2,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customer.value.address.town) = $event)),
                onChange: _cache[7] || (_cache[7] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.address.town,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((customer.value.address.county) = $event)),
                onChange: _cache[9] || (_cache[9] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.address.county,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((customer.value.address.postcode) = $event)),
                onChange: _cache[11] || (_cache[11] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.address.postcode,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((customer.value.address.phone) = $event)),
                onChange: _cache[13] || (_cache[13] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.address.phone,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.hqbranch,
                onValueChanged: _cache[14] || (_cache[14] = ($event: any) => (setCustomerDeep({ path: 'hqbranch', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.editable,
                onValueChanged: _cache[15] || (_cache[15] = ($event: any) => (setCustomerDeep({ path: 'editable', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})